import React from 'react';

const UniText = (props) => {
  let params = {};
  if (props.params) {
    params = props.params;
  }
  let title = params.title;

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__html-single-tag-phrasing' + extraClass;

  let tag = props.tag;
  let jsx = null;
  switch (tag) {
    case 'p':
      jsx = (<p className={cl}>{title}</p>);
      break;
    case 'h1':
      jsx = (<h1 className={cl}>{title}</h1>);
      break;
    case 'h2':
      jsx = (<h2 className={cl}>{title}</h2>);
      break;
    case 'h3':
      jsx = (<h3 className={cl}>{title}</h3>);
      break;
    case 'h4':
      jsx = (<h4 className={cl}>{title}</h4>);
      break;
    case 'h5':
      jsx = (<h5 className={cl}>{title}</h5>);
      break;
    case 'div':
      jsx = (<div className={cl}>{title}</div>);
      break;
    case 'span':
      jsx = (<span className={cl}>{title}</span>);
      break;
    default:
      jsx = (<p className={cl}>{title}</p>);
  }

  return (
    <>
      {jsx}
    </>
  );
};

export default UniText;